module.exports = __webpack_public_path__ + "static/media/SING.14b9d937.png";